<template>
  <div id="app">
    <navigation></navigation>
    <keep-alive
      include="Index,About,Contact,Anli,Dssj,Weixin,Wzjs,Wzyx,Fangan,Zhishi,Zhishi-app,Zhishi-dianshang,Zhishi-ruanjian,Zhishi-tuiguang,Zhishi-wangzhan,Zhishi-xiaochengxu">
      <router-view />
    </keep-alive>
    <Footer></Footer>
  </div>
</template>

<script>
import navigation from '@/components/Navigation/index'
import Footer from '@/components/Footer/index'

export default {
  name: 'app',
  components: {
    navigation,
    Footer
  },
  mounted() {
    // var hm = document.createElement("script");
    // hm.src = "https://hm.baidu.com/hm.js?6fdb5d3f2fbc4febee60ab68862b9674";
    // var s = document.getElementsByTagName("script")[0];
    // s.parentNode.insertBefore(hm, s);

    // var bp = document.createElement('script');
    // var curProtocol = window.location.protocol.split(':')[0];
    // if (curProtocol === 'https') {
    //   bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
    // }
    // else {
    //   bp.src = 'http://push.zhanzhang.baidu.com/push.js';
    // }
    // var s = document.getElementsByTagName("script")[0];
    // s.parentNode.insertBefore(bp, s);
  }
}

</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
